import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavLink } from "react-router-dom";
import { url } from "../link";
import Navbar from "../components/Navbar";
function Title2025() {
  const [titles, setTitles] = useState([]);
  const [modalData, setModalData] = useState({
    title: "",
    domain: "",
    basepaper: "",
  });
  const [editId, setEditId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const API_URL = url + "/edusphere/titles";

  useEffect(() => {
    fetchTitles();
  }, []);

  const fetchTitles = () => {
    axios.get(API_URL).then((res) => setTitles(res.data));
  };

  const handleChange = (e) => {
    setModalData({ ...modalData, [e.target.name]: e.target.value });
  };

  const handleAdd = () => {
    setModalData({ title: "", domain: "", basepaper: "" });
    setEditId(null);
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setModalData(item);
    setEditId(item.project_title_id);
    setShowModal(true);
  };

  const handleDelete = (id) => {
    axios.delete(`${API_URL}/${id}`).then(fetchTitles);
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("title", modalData.title);
    formData.append("domain", modalData.domain);

    // Append file only if it's a File object (not a string)
    if (modalData.basepaper instanceof File) {
      formData.append("basepaper", modalData.basepaper);
    }

    const urls = editId
      ? `${url}/edusphere/titles/${editId}`
      : `${url}/edusphere/titles`;

    const method = editId ? "put" : "post";

    axios({
      method: method,
      url: urls,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    }).then(() => {
      setShowModal(false);
      fetchTitles();
    });
  };

  return (
    <div className="container-fluid mt-4">
      <Navbar />
      <h2 className="mb-3">Project Titles</h2>
      <button className="btn btn-primary mb-3" onClick={handleAdd}>
        Add Title
      </button>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Domain</th>
            <th>Base Paper</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {titles.map((item) => (
            <tr key={item.project_title_id}>
              <td>{item.project_title_id}</td>
              <td>{item.title}</td>
              <td>{item.domain}</td>
              <td>
                {item.basepaper ? (
                  <a
                    href={`${url}/uploads/${item.basepaper}`}
                    target="_blank"
                    rel="noreferrer"
                    download
                  >
                    Download PDF
                  </a>
                ) : (
                  "No file"
                )}
              </td>
              <td>
                <button
                  className="btn btn-sm btn-warning me-2"
                  onClick={() => handleEdit(item)}
                >
                  Edit
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDelete(item.project_title_id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Bootstrap Modal */}
      {showModal && (
        <div className="modal show fade d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editId ? "Edit" : "Add"} Title</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <input
                  className="form-control mb-2"
                  name="title"
                  placeholder="Title"
                  value={modalData.title}
                  onChange={handleChange}
                />
                <select
                  className="form-control mb-2"
                  name="domain"
                  value={modalData.domain}
                  onChange={handleChange}
                >
                  <option value="">Select Domain</option>
                  <option value="cloud">Cloud</option>
                  <option value="ml">Machine Learning</option>
                  <option value="dl">Deep Learning</option>
                  <option value="blockchain">Blockchain</option>
                  <option value="cybersecurity">Cybersecurity</option>
                  <option value="iot">IoT</option>
                  <option value="iot&ml">IoT & ML</option>
                  <option value="cloud&blockchain">Cloud & Blockchain</option>
                  <option value="mobile app">Mobile App</option>
                  <option value="webapp">Web App</option>
                </select>
                <input
                  type="file"
                  className="form-control mb-2"
                  name="basepaper"
                  onChange={(e) =>
                    setModalData({ ...modalData, basepaper: e.target.files[0] })
                  }
                />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={handleSubmit}>
                  {editId ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Title2025;
